import { Card, styled, Box } from '../../../base';

export const CardWrapper = styled(Card)(({ theme }) => ({
    padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
    display: 'flex',
    height: '100%',
    width: '100%',
}));

export const NextActionDetails = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    alignItems: 'center',
    alignContent: 'center',
    width: 'fit-content',
}));
